import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTabs',
  setup(__props) {

const SimpleTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/SimpleTabs.vue"))
const IconTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/IconTabs.vue"))
const VerticalTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/VerticalTabs.vue"))
const PillsTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/PillsTabs.vue"))
const JustifyTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/JustifyTabs.vue"))
const LeftTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/LeftTabs.vue"))
const MaterialTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/MaterialTabs.vue"))
const BorderTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/BorderTabs.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(SimpleTabs)),
      _createVNode(_unref(IconTabs)),
      _createVNode(_unref(VerticalTabs)),
      _createVNode(_unref(PillsTabs)),
      _createVNode(_unref(JustifyTabs)),
      _createVNode(_unref(LeftTabs)),
      _createVNode(_unref(MaterialTabs)),
      _createVNode(_unref(BorderTabs))
    ])
  ]))
}
}

})